var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { align: "center" } }, [
    _c("span", { style: _vm.style }, [_c("i", { class: _vm.icon })])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }